import type { TravelFeatureConfig } from '../../../types/insurances/TravelFeatureConfig';

export const travel: TravelFeatureConfig = {
    overview: {
        details: {
            showContractedInsurances: false,
            showVariant: false,
            showPackage: false,
            showStartDateWithTime: false,
            showContractHolder: false,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
        showLinkedCards: false,
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
